const getRedirectUri = (): string => {
  const baseUrl = window.location.hostname;
  return `https://${baseUrl}${process.env.REACT_APP_FHIR_REDIRECT_PATH}`;
};

const getClientId = (): string => {
  // Check if production client ID exists
  if (!process.env.REACT_APP_FHIR_CLIENT_ID_PROD) {
    return process.env.REACT_APP_FHIR_CLIENT_ID || "";
  }

  // Check if hostname contains qa-app or staging
  const hostname = window.location.hostname;
  if (hostname.includes("qa-app") || hostname.includes("staging")) {
    return process.env.REACT_APP_FHIR_CLIENT_ID || "";
  }

  // Otherwise return production client ID
  return process.env.REACT_APP_FHIR_CLIENT_ID_PROD;
};

// FHIR Client Configuration
export const FHIR_CONFIG = {
  // Client ID registered with the FHIR server
  clientId: getClientId(),
  redirectUri: getRedirectUri(),
  scope: "launch openid fhirUser",
  // ISS parameter will be provided by the EHR during launch
  // FHIR server URL will be determined dynamically
};
